import * as React from 'react';

export const CreateAIFeed = React.lazy(() => import('./CreateAIFeed'));
